/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopayEntry } from './CopayEntry';
import {
    CopayEntryFromJSON,
    CopayEntryFromJSONTyped,
    CopayEntryToJSON,
    CopayEntryToJSONTyped,
} from './CopayEntry';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
    ValueWithNoteToJSONTyped,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseDataCoverageAmounts
 */
export interface StructuredAnalysisResponseDataCoverageAmounts {
    /**
     * 
     */
    copay?: Array<CopayEntry>;
    /**
     * 
     */
    out_of_pocket_maximum?: ValueWithNote;
    /**
     * 
     */
    out_of_pocket_spent?: ValueWithNote;
    /**
     * 
     */
    out_of_pocket_remaining?: ValueWithNote;
    /**
     * 
     */
    deductible?: ValueWithNote;
    /**
     * 
     */
    deductible_spent?: ValueWithNote;
    /**
     * 
     */
    deductible_remaining?: ValueWithNote;
    /**
     * 
     */
    coinsurance?: ValueWithNote;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseDataCoverageAmounts interface.
 */
export function instanceOfStructuredAnalysisResponseDataCoverageAmounts(value: object): value is StructuredAnalysisResponseDataCoverageAmounts {
    return true;
}

export function StructuredAnalysisResponseDataCoverageAmountsFromJSON(json: any): StructuredAnalysisResponseDataCoverageAmounts {
    return StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseDataCoverageAmounts {
    if (json == null) {
        return json;
    }
    return {
        
        'copay': json['copay'] == null ? undefined : ((json['copay'] as Array<any>).map(CopayEntryFromJSON)),
        'out_of_pocket_maximum': json['out_of_pocket_maximum'] == null ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_maximum']),
        'out_of_pocket_spent': json['out_of_pocket_spent'] == null ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_spent']),
        'out_of_pocket_remaining': json['out_of_pocket_remaining'] == null ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_remaining']),
        'deductible': json['deductible'] == null ? undefined : ValueWithNoteFromJSON(json['deductible']),
        'deductible_spent': json['deductible_spent'] == null ? undefined : ValueWithNoteFromJSON(json['deductible_spent']),
        'deductible_remaining': json['deductible_remaining'] == null ? undefined : ValueWithNoteFromJSON(json['deductible_remaining']),
        'coinsurance': json['coinsurance'] == null ? undefined : ValueWithNoteFromJSON(json['coinsurance']),
    };
}

export function StructuredAnalysisResponseDataCoverageAmountsToJSON(json: any): StructuredAnalysisResponseDataCoverageAmounts {
    return StructuredAnalysisResponseDataCoverageAmountsToJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageAmountsToJSONTyped(value?: StructuredAnalysisResponseDataCoverageAmounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'copay': value['copay'] == null ? undefined : ((value['copay'] as Array<any>).map(CopayEntryToJSON)),
        'out_of_pocket_maximum': ValueWithNoteToJSON(value['out_of_pocket_maximum']),
        'out_of_pocket_spent': ValueWithNoteToJSON(value['out_of_pocket_spent']),
        'out_of_pocket_remaining': ValueWithNoteToJSON(value['out_of_pocket_remaining']),
        'deductible': ValueWithNoteToJSON(value['deductible']),
        'deductible_spent': ValueWithNoteToJSON(value['deductible_spent']),
        'deductible_remaining': ValueWithNoteToJSON(value['deductible_remaining']),
        'coinsurance': ValueWithNoteToJSON(value['coinsurance']),
    };
}

